import type { StowedElement } from '@/api/types/stowed-element'
import { normalizeTemplateRotatedFrame } from './normalize-template-rotated-frame'

/**
 * One template element as a checkpoint row (`{ objectId, kindId, fractionalIndex, decodedData,
 * elements }`), the shape `checkpointToShapes` reads, so a template loads through exactly the path
 * a reloaded spread does.
 *
 * The object id, fractional index and uid are the backend's: it assigned them for this placement,
 * above the spread's own, and the template's text chains name those uids. Only what describes a
 * stored element (`versionId`, `signedUrl`) is dropped, since nothing is stored yet. A rotated
 * element's `visible*` box is first reset to its own frame (`normalizeTemplateRotatedFrame`), since
 * a legacy NSD's is not the centre and size Larry reads it as.
 */
export function wrapTemplateElement(element: StowedElement): Record<string, unknown> {
  const {
    elements: children,
    versionId: _versionId,
    signedUrl: _signedUrl,
    fractionalIndex,
    ...decoded
  } = normalizeTemplateRotatedFrame(element)

  return {
    objectId: element.objectId,
    kindId: element.kindId,
    ...(fractionalIndex ? { fractionalIndex } : {}),
    decodedData: decoded,
    elements: (children ?? []).map(wrapTemplateElement),
  }
}
